import script from "./SendEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SendEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./SendEmailModal.vue?vue&type=style&index=0&id=d9ac5766&lang=scss&scoped=true"

import exportComponent from "/home/atsuser/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9ac5766"]])

export default __exports__